<mat-card class="stepper">
  <div class="allSteps">
    <div [ngClass]="step >1 ? 'active step done' : 'active step'">
      <div class="stepStatus">
        <span class="nmbr">1</span>       
        <span class="stepIcon">
          <mat-icon>picture_as_pdf</mat-icon>
        </span>
      </div>
    </div>

    <div class="step" [ngClass]="step >2 ? 'active step done' : 'active step'">
        <div class="stepStatus">
            <span class="nmbr">2</span> 
            <span class="stepIcon">
              <mat-icon>account_box</mat-icon>
            </span>
          </div>
    </div>

    <div class="step"  [ngClass]="step >3 ? 'active step done' : 'active step'">      
        <div class="stepStatus">
            <span class="nmbr">3</span>           
            <span class="stepIcon">
              <mat-icon>design_services</mat-icon>
            </span>
        </div>
    </div>
  
  </div>

  <div class="stepAct">
    <button *ngIf="step > 1" mat-flat-button color="basic" (click)="back()" matTooltip="Back">
      Back
    </button>
    <button matTooltip="Next" *ngIf="step !=3" [disabled]="!StepNextButton" (click)="proceed()" mat-flat-button color="primary">
      Next
    </button>
    <button matTooltip="Next" *ngIf="step ==3 && !IsValid" [disabled]="!StepNextButtonStep3" (click)="ValidateCSV()" mat-flat-button color="primary">
      Next
    </button>
    <button matTooltip="Import" *ngIf="IsValid" [disabled]="ImportButton" (click)="ImportClick()" mat-flat-button color="primary">
      Import
    </button>
  </div>
</mat-card>

<div *ngIf="step == 1" class="section">
    <div class="oneblk">
        <mat-card (click)="CCCSelect($event,link)" class="impBlock" *ngFor="let link of menuModulesList">
            <mat-radio-button color="primary" [checked]="link.isChecked" (change)="CCCSelect($event,link)"></mat-radio-button>
            <mat-icon>{{link.icon}}</mat-icon>
            <h3>{{link.orgModuleName}}</h3>
            <p>People you work with commonly called {{link.orgModuleName}}</p>
        </mat-card>   
    </div>
</div>

<div *ngIf="step == 2" class="section">
  <div class="formWrapper">
    <mat-card class="container">
      <div class="page_header">
        <span>Upload Document (CSV format only)</span>
      </div>

      <div class="step one" id="step1">
        <mat-card class="documentList">
          <div class="importFile">
            <div class="upDoc">
              <div class="uploadholder">
                <input #Input type="file" name="files" (change)="uploadCSVFile(Input.files)" accept=".csv"/>                    
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
                  <path id="csv-icon" d="M3.886,34A3.833,3.833,0,0,1,0,30.222V3.778A3.833,3.833,0,0,1,3.886,0h13.6L27.2,9.444v3.778H34V28.333H27.2v1.889A3.833,3.833,0,0,1,23.314,34Zm5.829-7.556H32.057V15.111H9.714Zm6.8-16.056H24.05L16.514,3.063Zm9.014,14.167-1.243-3.624V17h1.943v3.625l.7,2.041h.543l.7-2.042V17h1.943v3.931l-1.243,3.624Zm-8.043,0V22.667h3.4a.472.472,0,1,0,0-.944h-.971a2.362,2.362,0,1,1,0-4.722h3.4v1.889h-3.4a.472.472,0,1,0,0,.944h.971a2.362,2.362,0,1,1,0,4.722Zm-2.914,0a2.878,2.878,0,0,1-2.914-2.833V19.833A2.878,2.878,0,0,1,14.571,17h1.943v1.889H14.571a.959.959,0,0,0-.971.944v1.889a.959.959,0,0,0,.971.944h1.943v1.889Z" fill="#6e7679"/>
                </svg>                
                <div class="textIn">
                  <p>Drag and drop csv file here</p>
                  <span class="ml-5 mr-5">or</span>
                  <p>click here to browse the csv file</p>
                </div>
              </div>
            </div>
          </div>

          
           <br>
          <mat-radio-group aria-label="Select an option">
            <mat-radio-button class="radOpt" value="Import All" [checked]="ImportAll" (change)="ChangeGroupType($event,1)">Import All</mat-radio-button>
           
            <!-- <mat-radio-button class="radOpt" value="De-Duplicate" [checked]="DeDuplicate" (change)="ChangeGroupType($event,2)">De-Duplicate</mat-radio-button> -->
            
            <mat-radio-button class="radOpt" value="Archive Only" [checked]="ArchiveOnly" (change)="ChangeGroupType($event,3)">Archive Only</mat-radio-button>
           
            <!-- <mat-radio-button class="radOpt" value="Archive & Import" [checked]="ArchiveImport" (change)="ChangeGroupType($event,4)">Archive & Import</mat-radio-button>                    -->
          </mat-radio-group>

          <br>
          <p>Select "Import All" if you want to Import all csv.</p>
          <p>Select "Archive Only" if you want to Archive all matching records from csv.</p>
          <!-- <p *ngIf="showContent!=''">{{showContent}}</p> -->
        </mat-card>
       
        <mat-card class="uploadDocuments" *ngIf="UploadedFiles.length > 0">
          <h3>Uploaded</h3>
          <div class="fileHolder">
            <div class="example-box" *ngFor="let file of UploadedFiles">
              <ng-container>
                <mat-card class="fileCont">
                  <div class="DragIcon">
                    <mat-icon>drag_indicator</mat-icon>
                  </div>

                  <div class="Icon">
                    <img src="../../../../assets/icons/fileType/csv-icon34.svg" alt="csv File"/>
                  </div>

                  <div class="nameInfo">
                    <h2>{{ file.fileName }}</h2>
                    <p>{{ file.Totalsize }}</p>
                  </div>

                  <div class="docAct">
                    <button mat-icon-button  color="basic" matTooltipClass="tooltip" matTooltip="Delete" (click)="deleteFileFromUploaded()">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </div>
                </mat-card>
              </ng-container>
            </div>
          </div>
        </mat-card>
      </div>
    </mat-card>
  </div>
</div>


<div *ngIf="step == 3" class="section">
  <div class="new-datatable">  
    <div class="required-properties" *ngIf="ErrorMessage">
      <div class="required-text">
        <h5>Some required properties are missing</h5>
        <p> Mismatched columns will not be imported         
          To complete your contacts import, you need <span class="color-dark">First Name</span> or <span class="color-dark">last Name</span> or <span class="color-dark">Email</span> as a Hubspot property. Please review your property mappings below or review the columns in your file.</p>
      </div>
    </div>

    <div class="table">
      <table>
        <thead>
          <th width="90px"> Sr. No.</th>
          <th width="130px">
              <div class="inline-items-custom">
                  <mat-checkbox color="primary" [disabled]="disabledGrid" [checked]="checkedAll" (change)="getCheckboxAll($event)"></mat-checkbox>
                  Import <i class="fa fa-info-circle" aria-hidden="true"  matTooltip="Only selected column header will be import"></i><br>
               </div>            
          </th>
          <th>Column Header From File</th>         
          <th>System Fields</th>          
        </thead>       
        <tbody *ngFor="let file of columnsNewHeader">
          <tr>           
            <td>{{file.id}}</td>
            <td>
              <div class="has-checkbox">
                <mat-checkbox color="primary" [disabled]="disabledGrid" [checked]="file.IsImport" (change)="getCheckboxParticular($event,file)"></mat-checkbox>
              </div>
            </td>           
            <td>{{file.CsvFieldName}}</td>
            <td >             
              <mat-form-field>
                <mat-label>Choose fields</mat-label>
                <mat-select  [disabled]="disabledGrid" class="custom-select-style"   (selectionChange)="selectFeildProperty($event,file)" >               
                  <mat-option *ngFor="let pro of Feildproperty" [value]="pro.fieldID">
                  {{ pro.fieldName }}
                  </mat-option>
                </mat-select>
              </mat-form-field> 
              <!-- <mat-form-field>
                <mat-label>Choose fields</mat-label>
                <mat-select  [disabled]="disabledGrid" class="custom-select-style"   (selectionChange)="selectFeildProperty($event,file)" >               
                  <mat-option *ngFor="let pro of file.Feildproperty" [value]="pro.fieldID">
                  {{ pro.fieldName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>  -->
            </td>                      
           </tr>         
        </tbody>
      </table>
    </div>
  </div>
</div>


<app-loader></app-loader>